import {ofType} from 'redux-observable';
import i18next from 'i18next';
import {flatMap, filter, map, mapTo} from 'rxjs/operators';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';
import * as ContactActions from 'web-app/react/entities/contacts/actions';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Actions from './actions';

const confirmDeleteEmployeeContactEpic = action$ =>
    action$.pipe(
        ofType(Actions.confirmDeleteEmployeeRelation.type),
        flatMap(({payload}: ReturnType<typeof Actions.confirmDeleteEmployeeRelation.action>) =>
            showDeleteDialogObservable({
                title: '',
                description: i18next.t('childProfile.confirmRelationDelete', {name: payload.contact.name.fullName}),
            }).pipe(
                filter(selection => selection === 'OK'),
                mapTo(ContactActions.deleteEmployeeContact.action(payload.contact)),
            ),
        ),
    );

const updateConfirmationEpic = (action$, state$) =>
    action$.pipe(
        ofType(ContactActions.updateEmployeeContactSuccess.type),
        filter(({payload}) => payload.employeeId === state$.value.employeeProfile.employeeId),
        map(() => GlobalEventActions.updateSuccess.action(i18next.t('childProfile.relationUpdated'))),
    );

export default combineEpics(confirmDeleteEmployeeContactEpic, updateConfirmationEpic);
